// This does some type checkig and ensures, that translations are not forgotten
// TODO: It currently doesn't work for nested objects
// Courtesy to ChatGPT for this beauty ;)

import { Language } from "./Language";

// This function doesn't do anything, it just helps with typecheck
export function createContent<
  T1 extends LanguageContent,
  T extends LanguageObject<T1>
>(content: T): T {
  return content;
}

export type LanguageContent = Record<string, any>;
export type LanguageObject<T extends LanguageContent> = {
  [K in Language]: T;
};

export type ContentType<T> = T extends LanguageObject<infer U> ? U : never;